import { render, staticRenderFns } from "./ModuleToggle.vue?vue&type=template&id=59b6e413&scoped=true"
import script from "./ModuleToggle.vue?vue&type=script&lang=js"
export * from "./ModuleToggle.vue?vue&type=script&lang=js"
import style0 from "./ModuleToggle.vue?vue&type=style&index=0&id=59b6e413&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b6e413",
  null
  
)

export default component.exports